import axios from 'axios';

const key = process.env.REACT_APP_OPENAI_API_KEY

const sendAudioToOpenAIWhisper = async (audioBlob) => {
    const formData = new FormData();
    formData.append('file', audioBlob, 'audio.webm');
    formData.append('model', 'whisper-1');
    formData.append('response_format', 'text');
    formData.append('language', 'en');

    try {
        const response = await axios.post(
            'https://api.openai.com/v1/audio/transcriptions',
            formData,
            {
                headers: {
                    Authorization: `Bearer ${key}`,
                    // Remove the 'Content-Type' header
                },
            }
        );
       
        // console.log('data',response.data);
        // Return the response data if the API call is successful
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        // Log the error for debugging
        console.error("Error in fetching text from audio",error);
    }
};

export default sendAudioToOpenAIWhisper;
